const Main = (props) => {
  return <div>{props.children}</div>;
};

export default Main;
